import { StarsButton, type TrackedTranslation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import WarningIcon from '@swf/core/assets/icons/warning.svg';
import type { Dispatch } from '@swf/core/store';
import { useWidgetTheme } from '@swf/poker';

import BaseHeader from '../BaseHeader/BaseHeader';

import { TXTCLI_OK } from './ActiveTableLimit.messages.json';
import styles from './ActiveTableLimit.scss';

interface Props {
  text: React.ReactNode;
  buttonText: TrackedTranslation;
}

const ActiveTableLimit: React.FC<Props> = () => {
  const { modal } = useDispatch<Dispatch>();
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const { className } = useWidgetTheme();

  useEffect(() => {
    setStyle({
      overlayClassName: classNames(className, styles.modalOverlay),
      className: classNames(styles.modalContainer, styles.modalContainerCentered),
      closeOnOverlayClick: true,
      closeOnEsc: true
    });
  }, [className, setStyle]);

  return (
    <div>
      <BaseHeader headerClassName={styles.header} title="Maximum Tables Reached" />
      {/* 
        TODO: Use this translation when it is available
        <Header title={<Translation {...TXTCLI_Maximum_tables_reached} />} /> 
      */}
      <div className={styles.body}>
        <WarningIcon width="60" height="60" className={styles.warningIcon} />
        <p>
          You can only play 4 tables at the same time.
          {/* 
            TODO: Use this translation when it is available
            <Translation
              {...TXTCLI_If_you_leave_before_playing_a__ELL_1}
              values={{ 0: MAX_ACTIVE_GAMES }}
            /> 
          */}
        </p>
        <StarsButton
          className={styles.button}
          onClick={() => modal.close()}
          translation={TXTCLI_OK}
        />
      </div>
    </div>
  );
};

export default ActiveTableLimit;
